import React from "react";
import { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import ClearIcon from "@mui/icons-material/Clear";
import DoneOutlineRounded from "@mui/icons-material/DoneOutlineRounded";

import FormHelperText from '@mui/material/FormHelperText';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import api from "../../service/api";
import Page from "../../layout/Page";
import Loading from "../../layout/Loading";

const TabContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    paddingRight: theme.spacing(10),
    paddingLeft: theme.spacing(10),
  },
}));

const Row = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));


const DatosPersonales = (props) => {

  const breadcrumbs = [
    { nombre: "Inicio", ruta: "/" },
    { nombre: "Datos Personales", ruta: "" },
  ];

  const hoy = new Date();
  let mes = '';
  let dia = '';


  if ((hoy.getMonth() + 1) < 10) {
    mes = hoy.getMonth() + 1;
    mes = '0' + mes;
  } else {
    mes = hoy.getMonth() + 1;
  }

  if ((hoy.getDate() + 1) < 10) {
    dia = hoy.getDate();
    dia = '0' + dia;
  } else {
    dia = hoy.getDate();
  }

  const fechaActual = hoy.getFullYear() + '-' + mes + '-' + dia;

  const [dni, setDni] = useState("");
  const [apellido, setApellido] = useState("");
  const [nombre, setNombre] = useState("");
  const [fecha_nacimiento, setFecha_nacimiento] = useState("");
  const [domicilio_real, setDomicilio_real] = useState("");
  const [localidad_reside, setLocalidad_reside] = useState("");
  const [telefono, setTelefono] = useState("");
  const [email, setEmail] = useState("");  
  const [formacion_id, setFormacion_id] = useState("");
  const [estado_formacion_id, setEstado_formacion_id] = useState("");
  const [direccion_administracion, setDireccion_administracion] = useState("");
  const [dependencia, setDependencia] = useState("");
  const [localidad_trabaja, setLocalidad_trabaja] = useState("");
  const [planta_id, setPlanta_id] = useState("");
  const [submitting, setSubmitting] = useState(true);
  const [datosPlanta, setDatosPlanta] = useState([]);
  const [datosLocalidad, setDatosLocalidad] = useState([]);
  const [datosFormacionAcademica, setDatosFormacionAcademica] = useState([]);
  const [datosEstadoFormacionAcademica, setDatosEstadoFormacionAcademica] = useState([]);
  const [datosDireccionAdministracion, setDatosDireccionAdministracion] = useState([]);

  const [checkedProvincial, setCheckedProvincial] = useState(false);
  const [checkedMunicipal, setCheckedMunicipal] = useState(false);
  const [visible, setVisible] = useState(true);

  const [mensaje, setMensaje] = useState("");
  const [tipoMensaje, setTipoMensaje] = useState("");


  const validationSchema = Yup.object().shape({
    documento: Yup.string()
      .min(6, 'Minimo 6 dígitos')
      .max(8, 'Máximo 8 dígitos')
      .required('Requerido'),
    apellido: Yup.string()
      .min(2, 'Minimo 2 dígitos')
      .max(200, 'Máximo 200 dígitos')
      .required('Requerido'),
    nombre: Yup.string()
      .min(3, 'Minimo 3 dígitos')
      .max(200, 'Máximo 200 dígitos')
      .required('Requerido'),
    fecha_nacimiento: Yup.date()
      .typeError("Formato no válido")
      .required('Requerido')
      .max(new Date(Date.now() - 567648000000), "Debe ser mayor de edad") 
      .min("01/01/1900", "Fecha incorrecta"),
    domicilio_real: Yup.string()
      .max(200, 'Máximo 200 dígitos')
      .required('Requerido'),
    localidad_reside: Yup.string()
      .required('Requerido'),
    telefono: Yup.string()
      .min(9, 'Minimo 9 dígitos')
      .max(15, 'Máximo 15 dígitos')
      .required('Requerido'),
    email: Yup.string()
      .email('E-mail incorrecto')
      .required('Requerido'),
    reingresoMail: Yup.string()
      .email('E-mail incorrecto')
      .required('Requerido')
      .oneOf([Yup.ref("email"), null], "Las direcciones de correo deben coincidir"),
    formacion_id: Yup.string()
      .required('Requerido'),
    estado_formacion: Yup.string()
      .required('Requerido'),
    direccion_administracion: Yup.string()
      .required('Requerido'),
    cod_planta: Yup.string()
      .required('Requerido'),
    dependencia: Yup.string()
      .max(200, 'Máximo 200 dígitos')
      .required('Requerido'),
    localidad_trabaja: Yup.string()
      .required('Requerido'),
  });

  const formik = useFormik({
    initialValues: {
      documento: (dni === '' || dni === null ? '' : dni),
      apellido: (apellido === '' || apellido === null ? '' : apellido),
      nombre: (nombre === '' || nombre === null ? '' : nombre),
      fecha_nacimiento: (fecha_nacimiento === '' || fecha_nacimiento === null ? fechaActual : fecha_nacimiento),
      domicilio_real: (domicilio_real === '' || domicilio_real === null ? '' : domicilio_real),
      localidad_reside: (localidad_reside === '' || localidad_reside === null ? '' : localidad_reside),
      telefono: (telefono === '' || telefono === null ? '' : telefono),
      email: (email === '' || email === null ? '' : email),
      reingresoMail: (email === '' || email === null ? '' : email),
      formacion_id: (formacion_id === '' || formacion_id === null ? '' : formacion_id),
      estado_formacion: (estado_formacion_id === '' || estado_formacion_id === null ? '' : estado_formacion_id),
      direccion_administracion: (direccion_administracion === '' || direccion_administracion === null ? '' : direccion_administracion),
      dependencia: (dependencia === '' || dependencia === null ? '' : dependencia),
      localidad_trabaja: (localidad_trabaja === '' || localidad_trabaja === null ? '' : localidad_trabaja),
      cod_planta: (planta_id === '' || planta_id === null ? '' : planta_id),
    },

    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      let datos = {
        fecha_nacimiento: values.fecha_nacimiento,
        domicilio_real: values.domicilio_real.toUpperCase(),
        localidad_reside: values.localidad_reside,
        localidad_trabaja: values.localidad_trabaja,
        telefono: values.telefono,
        email: values.email,
        direccion_administracion: values.direccion_administracion,
        dependencia: values.dependencia.toUpperCase(),
        formacion: values.formacion_id,
        estado_formacion: values.estado_formacion,
        cod_planta: values.cod_planta
      };
      api
        .modificarDatosPersonales(datos)
        .then((res) => {
          setTipoMensaje("S");
          setMensaje('Datos personales modificados correctamente');
        })
        .catch((e) => {
          setTipoMensaje("N");
          setMensaje(e.response.data.error);
        });
      setTimeout(() => {
        setTipoMensaje("");
        setSubmitting(false);
      }, 2500);
    },
    onReset: () => {

    },
  });

  const validarMailUsuario = (event) => {

    if (email !== event.target.value) {
      setTipoMensaje("");
      setMensaje("");
      let datos = {
        mail: event.target.value,
      }
      api
        .verificarMailAlumno(datos)
        .then((res) => {
          if (res.data[0].existe === 'N') {
            setSubmitting(false);
          } else {
            setTipoMensaje("N");
            setMensaje("El correo electrónico ingresado existe en nuestros registros para otro usuario del plan. Comuniquese con la Dirección General de Recursos Humanos.");
            setSubmitting(true);
          }
        })
        .catch((e) => {
          console.log("Error al validar el mail");
        });
    } else {
      setSubmitting(false);
      setTipoMensaje("");
      setMensaje("");
    }
  }

  const handleChangeTextField = (event) => {
    if (/^\d*$/.test(event.target.value)) {
      formik.setFieldValue(event.target.id, event.target.value);
    }
  };

  const buscarDatosPersonales = () => {
    setVisible(true);
    api
      .mostrarDatosPersonales()
      .then((res) => {
        setSubmitting(true);
        setDni(res.data[0].dni);
        setApellido(res.data[0].apellido);
        setNombre(res.data[0].nombre);
        setFecha_nacimiento(res.data[0].fecha_nacimiento);
        setDomicilio_real(res.data[0].domicilio_real);
        setLocalidad_reside(res.data[0].localidad_reside);
        setTelefono(res.data[0].telefono);
        setEmail(res.data[0].email);       
        setFormacion_id(res.data[0].formacion_id);
        setEstado_formacion_id(res.data[0].estado_formacion_id);
        setDireccion_administracion(res.data[0].direccion_administracion);
        setDependencia(res.data[0].dependencia);
        setLocalidad_trabaja(res.data[0].localidad_trabaja);
        setPlanta_id(res.data[0].planta_id);       
        buscarDireccionAdministracion(res.data[0].ambito_id);
        setVisible(false);
        if (res.data[0].ambito_id === '1') {
          setCheckedProvincial(true);
          setCheckedMunicipal(false);
        } else {
          setCheckedProvincial(false);
          setCheckedMunicipal(true);
        }
        setSubmitting(false);
      })
      .catch((e) => {
        console.log("Error al mostrar los datos personales");
      });
  };

  const buscarLocalidades = () => {
    api
      .listaLocalidades()
      .then((res) => {
        setDatosLocalidad(res.data);
      })
      .catch((e) => {
        console.log("Error al cargar los datos de las localidades");
      });
  };

  const buscarFormacionAcademica = () => {
    api
      .listaFormacionAcademica()
      .then((res) => {
        setDatosFormacionAcademica(res.data);
      })
      .catch((e) => {
        console.log("Error al cargar los datos de formación academicas");
      });
  };

  const buscarEstadoFormacionAcademica = () => {
    api
      .listaEstadoFormacionAcademica()
      .then((res) => {
        setDatosEstadoFormacionAcademica(res.data);
      })
      .catch((e) => {
        console.log("Error al cargar los datos de los estados de formaciones academicas");
      });
  };

  const buscarPlantas = () => {
    api
      .listaPlantas()
      .then((res) => {
        setDatosPlanta(res.data);
      })
      .catch((e) => {
        console.log("Error al cargar los datos de planta");
      });
  };

  const buscarDireccionAdministracion = (ambitoDa) => {
    api
      .listaDireccionAdministracion(ambitoDa)
      .then((res) => {
        setDatosDireccionAdministracion(res.data);
      })
      .catch((e) => {
        console.log("Error al cargar los datos de las direcciones de administración" + ambitoDa);
      });
  };

  const mostrarDireccionAdministracion = (value) => {
    switch (value) {
      case 1:
        setCheckedProvincial(true);
        setCheckedMunicipal(false);
        setDatosDireccionAdministracion([]);
        buscarDireccionAdministracion(1);
        break;
      case 2:
        setCheckedProvincial(false);
        setCheckedMunicipal(true);
        setDatosDireccionAdministracion([]);
        buscarDireccionAdministracion(2);
        break;
      default:
        setDatosDireccionAdministracion([]);
        setCheckedProvincial(false);
        setCheckedMunicipal(false);
    }
  };

  useEffect(() => {
    buscarLocalidades();
    buscarFormacionAcademica();
    buscarEstadoFormacionAcademica();
    buscarPlantas();
    buscarDatosPersonales();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page breadcrumbs={breadcrumbs}>
      {dni !== "" ? "" : <Loading />}
      <div hidden={visible}>

        <TabContainer>
          <Row container spacing={1}>
            <Grid item xs={12} sm={12} sx={{ marginBottom: 0 }}>
              <Typography variant="titulo"><b>DATOS PERSONALES</b></Typography>
            </Grid>
          </Row>
          <form
            id="formDatosPersonales"
            name="formDatosPersonales"
            onSubmit={formik.handleSubmit}
            onReset={formik.handleReset}
            noValidate
            autoComplete="off"
          >
            <Row container spacing={1}>
              <Grid item lg={4} xs={12}>
                <TextField
                  id="documento"
                  name="documento"
                  label="DOCUMENTO"
                  variant="outlined"
                  size="small"
                  fullWidth
                  onChange={handleChangeTextField}
                  value={formik.values.documento}
                  error={
                    formik.touched.documento &&
                    Boolean(formik.errors.documento)
                  }
                  helperText={
                    formik.touched.documento &&
                    formik.errors.documento
                  }
                  disabled
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <TextField
                  id="apellido"
                  name="apellido"
                  label="APELLIDO"
                  variant="outlined"
                  size="small"
                  disabled
                  fullWidth
                  value={formik.values.apellido.toUpperCase()}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.apellido &&
                    Boolean(formik.errors.apellido)
                  }
                  helperText={
                    formik.touched.apellido &&
                    formik.errors.apellido
                  }
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <TextField
                  id="nombre"
                  name="nombre"
                  label="NOMBRE"
                  variant="outlined"
                  size="small"
                  fullWidth
                  disabled
                  value={formik.values.nombre.toUpperCase()}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.nombre &&
                    Boolean(formik.errors.nombre)
                  }
                  helperText={
                    formik.touched.nombre &&
                    formik.errors.nombre
                  }
                />
              </Grid>
            </Row>

            <Row container spacing={1}>
              <Grid item lg={3} xs={12}>
                <TextField
                  id="fecha_nacimiento"
                  name="fecha_nacimiento"
                  label="FECHA DE NACIMIENTO"
                  variant="outlined"
                  size="small"
                  type="date"
                  fullWidth
                  onChange={formik.handleChange}
                  value={formik.values.fecha_nacimiento}
                  error={
                    formik.touched.fecha_nacimiento &&
                    Boolean(formik.errors.fecha_nacimiento)
                  }
                  helperText={
                    formik.touched.fecha_nacimiento &&
                    formik.errors.fecha_nacimiento
                  }
                />
              </Grid>
            </Row>

            <Row container spacing={1}>
              <Grid item lg={8} xs={12}>
                <TextField
                  id="domicilio_real"
                  name="domicilio_real"
                  label="DOMICILIO REAL"
                  variant="outlined"
                  size="small"
                  fullWidth
                  onChange={formik.handleChange}
                  value={formik.values.domicilio_real.toUpperCase()}
                  error={
                    formik.touched.domicilio_real &&
                    Boolean(formik.errors.domicilio_real)
                  }
                  helperText={
                    formik.touched.domicilio_real &&
                    formik.errors.domicilio_real
                  }
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <FormControl
                  variant="outlined"
                  size="small"
                  error={
                    formik.touched.localidad_reside && Boolean(formik.errors.localidad_reside)
                  }
                  fullWidth
                >
                  <InputLabel id="soporteLabel">LOCALIDAD</InputLabel>
                  <Select
                    labelId="localidad_resideLabel"
                    id="localidad_reside"
                    name="localidad_reside"
                    variant="outlined"
                    label="LOCALIDAD"
                    onChange={formik.handleChange}
                    value={formik.values.localidad_reside}
                  >
                    {
                      datosLocalidad.map(itemLocalidad => (
                        <MenuItem value={itemLocalidad.id_localidad}> {itemLocalidad.desc_localidad.toUpperCase()}</MenuItem>
                      ))
                    }
                  </Select>
                  <FormHelperText>
                    {formik.touched.localidad_reside && formik.errors.localidad_reside}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Row>

            <Row container spacing={1}>
              <Grid item lg={4} xs={12}>
                <TextField
                  id="telefono"
                  name="telefono"
                  label="NÚMERO CELULAR"
                  variant="outlined"
                  size="small"
                  fullWidth
                  onChange={handleChangeTextField}
                  value={formik.values.telefono}
                  error={
                    formik.touched.telefono &&
                    Boolean(formik.errors.telefono)
                  }
                  helperText={
                    formik.touched.telefono &&
                    formik.errors.telefono
                  }
                />
              </Grid>
              <Grid item lg={4} xs={12}>
                <TextField
                  id="email"
                  name="email"
                  label="CORREO ELECTRÓNICO"
                  variant="outlined"
                  size="small"
                  fullWidth
                  onBlur={validarMailUsuario}
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.email &&
                    Boolean(formik.errors.email)
                  }
                  helperText={
                    formik.touched.email &&
                    formik.errors.email
                  }
                />
              </Grid>
              <Grid item lg={4} xs={12}>
                <TextField
                  id="reingresoMail"
                  name="reingresoMail"
                  label="REINGRESAR CORREO ELECTRÓNICO"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={formik.values.reingresoMail}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.reingresoMail &&
                    Boolean(formik.errors.reingresoMail)
                  }
                  helperText={
                    formik.touched.reingresoMail &&
                    formik.errors.reingresoMail
                  }
                />
              </Grid>
            </Row>

            <Row container spacing={1}>
              <Grid item xs={12} sm={12} sx={{ marginBottom: 0 }}>
                <Typography variant="titulo"><b>DATOS ACADÉMICOS</b></Typography>
              </Grid>
            </Row>

            <Row container spacing={1}>
              <Grid item lg={4} xs={12}>
                <FormControl
                  variant="outlined"
                  size="small"
                  error={
                    formik.touched.formacion_id && Boolean(formik.errors.formacion_id)
                  }
                  fullWidth
                >
                  <InputLabel id="soporteLabel">NIVEL ACADÉMICO</InputLabel>
                  <Select
                    labelId="formacion_idLabel"
                    id="formacion_id"
                    name="formacion_id"
                    variant="outlined"
                    label="NIVEL ACADÉMICO"
                    onChange={formik.handleChange}
                    value={formik.values.formacion_id}
                  >
                    {
                      datosFormacionAcademica.map(itemNivel => (
                        <MenuItem value={itemNivel.id}>{itemNivel.nombre.toUpperCase()}</MenuItem>
                      ))
                    }
                  </Select>
                  <FormHelperText>
                    {formik.touched.formacion_id && formik.errors.formacion_id}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item lg={4} xs={12}>
                <FormControl
                  variant="outlined"
                  size="small"
                  error={
                    formik.touched.estado_formacion && Boolean(formik.errors.estado_formacion)
                  }
                  fullWidth
                >
                  <InputLabel id="estado_formacionLabel">ESTADO DE NIVEL ACADÉMICO</InputLabel>
                  <Select
                    labelId="estado_formacionLabel"
                    id="estado_formacion"
                    name="estado_formacion"
                    variant="outlined"
                    label="ESTADO DE NIVEL ACADÉMICO"
                    onChange={formik.handleChange}
                    value={formik.values.estado_formacion}
                  >
                    {
                      datosEstadoFormacionAcademica.map(itemEstadoFormacion => (
                        <MenuItem value={itemEstadoFormacion.id}> {itemEstadoFormacion.nombre.toUpperCase()}</MenuItem>
                      ))
                    }
                  </Select>
                  <FormHelperText>
                    {formik.touched.estado_formacion && formik.errors.estado_formacion}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Row>

            <Row container spacing={1}>
              <Grid item xs={12} sm={12} sx={{ marginBottom: 0 }}>
                <Typography variant="titulo"><b>DATOS LABORABLES</b></Typography>
              </Grid>
            </Row>

            <Row container spacing={1}>
              <Grid item lg={12} xs={12} align="center">
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel key="radioProvincial"
                      value="1"
                      control={<Radio />}
                      name="ambito"
                      id="provincial"
                      label="Trabajadores/as Provinciales   "
                      checked={checkedProvincial}
                      onChange={e => mostrarDireccionAdministracion(1)}
                    />
                    <FormControlLabel key="radioMunicipal"
                      value="2"
                      control={<Radio />}
                      name="ambito"
                      id="municipal"
                      label="Trabajadores/as de Gobiernos Locales"
                      checked={checkedMunicipal}
                      onChange={e => mostrarDireccionAdministracion(2)}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Row>

            <Row container spacing={1}>
              <Grid item lg={8} xs={12}>
                <FormControl
                  variant="outlined"
                  size="small"
                  error={
                    formik.touched.direccion_administracion && Boolean(formik.errors.direccion_administracion)
                  }
                  fullWidth
                >
                  <InputLabel id="soporteLabel">DIRECCIÓN DE ADMINISTRACIÓN</InputLabel>
                  <Select
                    labelId="direccion_administracionLabel"
                    id="direccion_administracion"
                    name="direccion_administracion"
                    variant="outlined"
                    label="DIRECCIÓN DE ADMINISTRACIÓN"
                    onChange={formik.handleChange}
                    value={formik.values.direccion_administracion}
                  >
                    {
                      datosDireccionAdministracion.map(itemDa => (
                        <MenuItem value={itemDa.id}> {itemDa.da.toUpperCase()}</MenuItem>
                      ))
                    }
                  </Select>
                  <FormHelperText>
                    {formik.touched.direccion_administracion && formik.errors.direccion_administracion}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item lg={4} xs={12}>
                <FormControl
                  variant="outlined"
                  size="small"
                  error={
                    formik.touched.cod_planta && Boolean(formik.errors.cod_planta)
                  }
                  fullWidth
                >
                  <InputLabel id="cod_plantaLabel">SITUACIÓN DE REVISTA</InputLabel>
                  <Select
                    labelId="cod_plantaLabel"
                    id="cod_planta"
                    name="cod_planta"
                    variant="outlined"
                    label="SITUACIÓN DE REVISTA"
                    onChange={formik.handleChange}
                    value={formik.values.cod_planta}
                  >
                    {
                      datosPlanta.map(itemPlanta => (
                        <MenuItem value={itemPlanta.cod_planta}> {itemPlanta.desc_planta.toUpperCase()}</MenuItem>
                      ))
                    }

                  </Select>
                  <FormHelperText>
                    {formik.touched.cod_planta && formik.errors.cod_planta}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Row>

            <Row container spacing={1}>
              <Grid item lg={7} xs={12}>
                <TextField
                  id="dependencia"
                  name="dependencia"
                  label="ORGANISMO DONDE PRESTA SERVICIO"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={formik.values.dependencia.toUpperCase()}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.dependencia &&
                    Boolean(formik.errors.dependencia)
                  }
                  helperText={
                    formik.touched.dependencia &&
                    formik.errors.dependencia
                  }
                />
              </Grid>
              <Grid item lg={5} xs={12}>
                <FormControl
                  variant="outlined"
                  size="small"
                  error={
                    formik.touched.cod_planta && Boolean(formik.errors.cod_planta)
                  }
                  fullWidth
                >
                  <InputLabel id="localidad_trabajaLabel">LOCALIDAD DONDE TRABAJA</InputLabel>
                  <Select
                    labelId="localidad_trabajaLabel"
                    id="localidad_trabaja"
                    name="localidad_trabaja"
                    variant="outlined"
                    label="LOCALIDAD DONDE TRABAJA"
                    onChange={formik.handleChange}
                    value={formik.values.localidad_trabaja}
                  >
                    {
                      datosLocalidad.map(itemLocalidad => (
                        <MenuItem value={itemLocalidad.id_localidad}> {itemLocalidad.desc_localidad.toUpperCase()}</MenuItem>
                      ))
                    }
                  </Select>
                  <FormHelperText>
                    {formik.touched.localidad_trabaja && formik.errors.localidad_trabaja}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Row>

            <Grid container justifyContent="space-between" spacing={0}>
              <Grid item align="left">
                {tipoMensaje === "S" ? (
                  <Typography variant="cuerpo" sx={{ color: '#799F4F' }}><b>{mensaje}</b></Typography>
                ) : (
                    tipoMensaje === "N" ? (
                      <Typography variant="cuerpo" sx={{ color: '#bf2b11' }}><b>{mensaje}</b></Typography>
                    ) : (
                        <Typography variant="cuerpo"></Typography>
                      ))
                }
              </Grid>
              <Grid
                item
                align="right"
              >
                <Box align="right">
                  <Link key="Inicio" to="/" style={{ textDecoration: 'none' }}>
                    <Button
                      variant="plata"
                      endIcon={<ClearIcon />}
                      sx={{ m: 1 }}
                    >
                      {"Cancelar"}
                    </Button>
                  </Link>
                  <Button
                    sx={{ m: 1 }}
                    variant="verde"
                    color="primary"
                    type="submit"
                    disabled={submitting}
                    endIcon={<DoneOutlineRounded />}
                  >
                    {submitting ? "Modificar" : "Modificar"}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </TabContainer>

      </div>

    </Page>
  );
}

export default DatosPersonales;